export default __webpack_public_path__ + "static/media/logo_casa_familia.e86a2e33.webp";